import { isMobile } from "react-device-detect";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ReactInputMask from "react-input-mask";

import "./step-1.scss";

const schema = yup.object().shape({
  nome: yup.string().required("Digite seu nome completo."),
  email: yup
    .string()
    .required("O campo email é obrigatório.")
    .email("Email não aceito."),
  cpf: yup
    .string()
    .required("O campo CPF é obrigatório.")
    .matches(
      /^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}$/,
      "CPF não aceito. Formato inválido!"
    ),
  telefone: yup
    .string()
    .required("Celular é uma informação obrigatória!")
    .matches(/\(\d{2}\)\s\d{5}-\d{4}/, "Formato de celular inválido!"),
  instagram: yup.string(),
});
function Step1({ nextStep }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    data.cpf = data.cpf.replace(/\D/g, "");
    data.telefone = data.telefone.replace(/\D/g, "");
    nextStep(data);
  };

  return (
    <form className="form step-1" onSubmit={handleSubmit(onSubmit)}>
      <div className={`${isMobile ? "" : "row"}`}>
        <div className={`${isMobile ? "" : "col-8"} mb-4`}>
          <label htmlFor="nome" className="form-label">
            Nome completo
          </label>
          <input
            type="text"
            className="form-control"
            id="nome"
            placeholder="Digite seu nome completo"
            {...register("nome")}
          />
          {errors.nome ? (
            <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-x-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
              </svg>
              <p>{errors.nome.message}</p>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="col mb-4">
          <label htmlFor="email" className="form-label">
            Seu e-mail *
          </label>
          <input
            type="text"
            className="form-control"
            id="email"
            placeholder="Digite seu melhor e-mail"
            {...register("email")}
          />
          {errors.email ? (
            <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-x-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
              </svg>
              <p>{errors.email.message}</p>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className={`${isMobile ? "" : "row"}`}>
        <div className="col mb-4">
          <label htmlFor="cpf" className="form-label">
            CPF *
          </label>
          <ReactInputMask
            className="form-control"
            mask="999.999.999-99"
            placeholder="Digite seu CPF"
            maskChar={null}
            {...register("cpf")}
          >
            {(inputProps) => <input {...inputProps} />}
          </ReactInputMask>
          {errors.cpf ? (
            <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-x-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
              </svg>
              <p>{errors.cpf.message}</p>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="col mb-4">
          <label htmlFor="telefone" className="form-label">
            Celular
            <small>preferência por whatsapp</small>
          </label>
          <ReactInputMask
            className="form-control"
            mask="(99) 99999-9999"
            placeholder="DDD + Celular"
            id="telefone"
            maskChar={null}
            {...register("telefone")}
          >
            {(inputProps) => <input {...inputProps} />}
          </ReactInputMask>
          {errors.telefone ? (
            <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-x-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
              </svg>
              <p>{errors.telefone.message}</p>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="col mb-4">
          <label htmlFor="instagram" className="form-label">
            Instagram
            <small>opcional</small>
          </label>
          <input
            type="text"
            className="form-control"
            id="instagram"
            placeholder="Usuário do seu instagram"
            {...register("instagram")}
          />
        </div>
      </div>
      <div className="form-text">
        <em>* Dados de acesso para efetuar o login na sua conta Adoleta.</em>
      </div>
      <button type="submit" className="btn mt-5 button-control button-next">
        Próximo
      </button>
    </form>
  );
}

export default Step1;
